import {
  PRECHECK_OPTIONS,
  OTHER_PRECHECK_OPTIONS,
  OTHER_PRECHECK_OPTIONS_REJECTED,
} from "businesslogic/constants/accountClosure";
import { isEmpty } from "lodash-es";
import {
  ACCOUNT_CLOSURE_PATHNAME_MAPPER
} from "../../constants/accountClosure";
import { MY_ACCOUNT_ROUTES } from "../../routeConstants/MyAccount";
import { getConfig } from "../../utils/functions";
import { nativeCallback } from "../../utils/native_callback";
import {
  capitalizeFirstLetter,
  inrFormatDecimal,
  storageService,
} from "../../utils/validators";

export const getChecklistViewData = (data = [], checklistData = {}) => {
  const nChecklistData = checklistData;
  const defaultStatus = "failed";

  const nData = data.map((item) => {
    item.status = nChecklistData[item.value]?.status || defaultStatus;

    if (nChecklistData[item.value]?.message) {
      item.sheetTitle = nChecklistData[item.value]?.message;
      if (item.value === "ledger_balance") {
        const tileData = nChecklistData[item.value]?.message?.split(":");
        item.sheetTitle = tileData[0] + ": " + inrFormatDecimal(tileData[1], 2);
      }
    }
    if (nChecklistData[item.value]?.content) {
      item.sheetSubtitle = nChecklistData[item.value]?.content;
    }
    return item;
  });

  return nData;
};

export const getRejectedChecklistViewData = (data = [], statusObj = {}) => {
  const defaultStatus = "success";

  let nData = [];
  if (isEmpty(statusObj)) {
    nData = data.map((item) => {
      item.status = defaultStatus;
      return item;
    });
  } else {
    nData = data.map((item) => {
      item.status = statusObj?.[item?.value] ? "success" : "failed";
      return item;
    });
  }

  return nData;
};

export const getPrecheckViewData = (
  checklistObject = {},
  isRejected = false,
  closureDetails = {}
) => {
  const isPrecheckPassed = checklistObject?.precheck === "success";
  const status = isRejected
    ? "rejected"
    : isPrecheckPassed
    ? "approved"
    : "failed";

  let data = [];
  if (isRejected) {
    const otherDataStatus = closureDetails?.file_info?.precheck_data || {};
    data = getRejectedChecklistViewData(PRECHECK_OPTIONS);
    const otherData = getRejectedChecklistViewData(
      OTHER_PRECHECK_OPTIONS_REJECTED,
      otherDataStatus
    );
    data = [...data, ...otherData];
  } else {
    data = getChecklistViewData(PRECHECK_OPTIONS, checklistObject);
    data = [...data, ...OTHER_PRECHECK_OPTIONS];
  }
  return { viewData: data, status };
};

export const getTextWithProductName = (text = "", productName = "fisdom") => {
  let subtitle = text;
  if (productName !== "fisdom") {
    subtitle = subtitle.replace("Fisdom", capitalizeFirstLetter(productName));
  }
  return subtitle;
};

export const getClosureStatusNav = (result) => {
  const status = result?.file_info?.status;
  let statusNav = "";
  let isRejected = false;

  if (status === "AccountClosure_Status.READY_TO_PROCESS") {
    // esign done, go to request verified
    statusNav = ACCOUNT_CLOSURE_PATHNAME_MAPPER.CLOSURE_VERIFED;
  } else if (status === "AccountClosure_Status.REQUEST_RAISED") {
    statusNav = ACCOUNT_CLOSURE_PATHNAME_MAPPER.CLOSURE_INIT;
    // go to Demat Closure Initiated Screen
  } else if (
    status === "AccountClosure_Status.REQUEST_REJECTED" &&
    result?.file_info?.remarks !== "retained"
  ) {
    statusNav = ACCOUNT_CLOSURE_PATHNAME_MAPPER.CHECKLIST_SCREEN;
    isRejected = true;
    // => Goto Precheck Screen, and show prechecks rejected
  } else if (status === "AccountClosure_Status.SIGN_PENDING") {
    statusNav = ACCOUNT_CLOSURE_PATHNAME_MAPPER.CLOSURE_APPROVED;
    // => Goto Request Approved => esign screen
  } else {
    statusNav = "";
  }

  return { statusNavlink: statusNav, isRejected };
};

export const navigateToStartOfJourney = (config, navigate, navigateProps) => {
  if (isEmpty(config)) {
    config = getConfig() || {};
  }
  const redirectFromRN = storageService().getObject('account-closure-rn-entry');
  storageService().remove('account-closure-rn-entry');

  if (redirectFromRN) {
    nativeCallback({ action: "exit_web" });
  } else {
    const path = config.isWebOrSdk ? MY_ACCOUNT_ROUTES.PROFILE_DETAILS : ACCOUNT_CLOSURE_PATHNAME_MAPPER.OTHER_OPTIONS;
    navigate(path, navigateProps);
  }
};

export const isAccountClosureInProgress = (kyc = {}) => {
  const isClosureInProgress = [
    "initiated",
    "sign_pending",
    "ready_to_process",
  ].includes(kyc?.equity_account_closure_status);
  return isClosureInProgress;
};
